import { createReducer, on } from "@ngrx/store";
import { FranchiseStateInterface } from "./franchiseState.interface";
import {
  resultFranchisedCompanyNamesByFranchise,
  resultFranchiseInfo,
  resultFranchiseList,
  resultMainDashboard,
  resultPaymentDetails,
  resultTopFranchised,
  setUpdateProfileSuccess,
  createFranchiseSuccess, 
  getFranchisesSuccess, 
  invokeFranchiseFilter,
  setFranchisesCompanyNames,
  updateFranchiseSuccess,
  setDeleteFranchiseSuccess,
  resultFranchisedsByFranchise,
  resultCompareLocations,
  invokeCompareLocations,
  invokeMainDashboard
} from "./franchise.action";

export const initialState: Readonly<FranchiseStateInterface> = {
  franchiseInfo: null,
  success: null,
  paymentDetails: null,
  franchiseList: [],
  franchiseMainDashboardDto: null,
  topFranchised: null,
  franchisedList: null,
  franchisedNamesList: [],
  franchisesResult: {
    count: 0,
    franchises: []
  },
  franchiseFilter: {
    zoneNames: [],
    companyName: null,
    searchCompanyName: null,
    companyNames: [],
    regions: [],
    showingAdmin: null,
    showingAdvertiser: null,
    partnerStatus: null,
    startDate: null,
    endDate: null,
    tags: [],
    subcategories: [],
    sortName: null,
    isAscending: true,
    pager: {
      pageNumber: 1,
      pageSize: 10,
    },
    isPaid: null,
  },
  companyNames: [],
  comparatorResults: [],
  loading: false,
  loadingMainDashboard : true
}

export const FranchiseReducer = createReducer(
  initialState,
  on(resultFranchiseInfo, (state, { franchiseInfo }) => ({
    ...state,
    franchiseInfo,
    loading: false,
  })),

  on(setUpdateProfileSuccess, (state, { success }) => ({
    ...state,
    success: success,
    loading: false,
  })),

  on(resultFranchisedCompanyNamesByFranchise, (state, { franchisedNamesList }) => ({
    ...state,
    franchisedNamesList,
  })),
  on(invokeMainDashboard, (state, { refreshCache }) => ({
    ...state,
    loadingMainDashboard : true
  })),
  
  on(resultMainDashboard, (state, { franchiseMainDashboardDto }) => ({
    ...state,
    franchiseMainDashboardDto: franchiseMainDashboardDto,
    loadingMainDashboard : false
  })),

  on(resultTopFranchised, (state, { topFranchised }) => ({
    ...state,
    topFranchised: topFranchised,
  })),

  on(resultFranchiseList, (state, { franchiseList }) => ({
    ...state,
    franchiseList: franchiseList,
  })),
  on(resultPaymentDetails, (state, { paymentDetails }) => ({
    ...state,
    paymentDetails: paymentDetails,
  })),
  on(createFranchiseSuccess, (state, { successMessage }) => ({
    ...state,
    success: successMessage,
  })),
  on(invokeFranchiseFilter, (state, { franchiseFilter }) => ({
    ...state,
    franchiseFilter: franchiseFilter,
    loading: true,
  })),
  on(getFranchisesSuccess, (state, { franchisesResult }) => ({
    ...state,
    franchisesResult: franchisesResult,
    loading: false,
  })),
  on(setFranchisesCompanyNames, (state, { companyNames }) => ({
    ...state,
    companyNames: companyNames,
    loading: false,
  })),
  on(updateFranchiseSuccess, (state, { success }) => ({
    ...state,
    success,
  })),
  on(setDeleteFranchiseSuccess, (state, { success }) => ({
    ...state,
    success,
  })),
  on(resultFranchisedsByFranchise, (state, { franchisedList }) => ({
    ...state,
    franchisedList,
  })),
  on(resultCompareLocations, (state, { comparatorResults }) => ({
    ...state,
    comparatorResults,
    loading: false
  })),
  on(invokeCompareLocations, (state, { data }) => ({
    ...state,
    loading: true,
  }))
);
